import React from "react"
import { Grid, IconButton, List } from "@material-ui/core"
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from "prop-types";

const ListItem = (props) => {
    return (
        <Grid container alignItems="stretch" style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '10px', marginBottom: '10px', padding: 0 }}>
            <Grid item xs={10} sm={11} style={{ gridAutoRows: '1fr' }}>
                <div style={{ height: '100%', padding: '5px' }}>
                    {props.children}
                </div>
            </Grid>
            <Grid item xs={2} sm={1} style={{ cursor: 'pointer', borderLeft: '1px solid #ccc' }}>
                <div style={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
                    {!props.readonly ?
                        <div
                            style={{ flex: '0 0 40%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid #ccc', borderRadius: '0 4px 0 0' }}
                            onClick={props.onDelete}
                        >
                            <IconButton size="small">
                                <DeleteIcon style={{ color: 'red' }} />
                            </IconButton>
                        </div>
                        :
                        null
                    }
                    <div
                        style={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '0 0 4px 0' }}
                        onClick={props.onView}
                    >
                        <IconButton size="small">
                            <VisibilityIcon />
                        </IconButton>
                    </div>
                </div>
            </Grid>
        </Grid>
    )
}

function ScrollableXList(props) {
    return (
        <div style={{
            fontSize: '0.95em',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
        }}>
            <span>{props.label}</span>
            <span style={{
                minWidth: 0, // Important for flex shrinking
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                WebkitScrollbar: { display: 'none' },
                msOverflowStyle: 'none', // Hide scrollbar for IE/Edge
                scrollbarWidth: 'none', // Hide scrollbar for Firefox,
                fontStyle: 'italic',
                paddingRight: '5px'
            }}>
                {props.text}
            </span>
        </div>
    )
}

ScrollableXList.propTypes = {
    label: PropTypes.string,
    text: PropTypes.string
}

ListItem.propTypes = {
    onDelete: PropTypes.func,
    onView: PropTypes.func,
    readonly: PropTypes.bool,
}

ListItem.ScrollableXList = ScrollableXList;

export default ListItem;